export default __webpack_public_path__ + "static/media/carousel-right-arrow.116c9622.svg";